// import Layout from "../Layout";
// import DashboardLayout from "../DashboardLayout";
// import ManageFeeds from "../ManageFeeds";
// import Inbox from "../Inbox";
// import Follows from "../Follows";
// import ProfileSettingsLayout from "../ProfileSettingsLayout";
// import ProfileSettings from "../Profilesettings--profile";
// import FrontpageSettings from "../Profilesettings--frontpage-settings";
// import ArticlesLayout from "../ArticlesLayout";
// import ArticlesList from "../ArticlesLayout--list";
// import ArticlesEditor from "../ArticlesLayout--editor";
const Layout = () => import(/* webpackChunkName: "group-private" */ '../Layout.vue')
const DashboardLayout = () => import(/* webpackChunkName: "group-private" */ '../DashboardLayout.vue')
const ManageFeeds = () => import(/* webpackChunkName: "group-private" */ '../ManageFeeds.vue')
const Inbox = () => import(/* webpackChunkName: "group-private" */ '../Inbox.vue')
const Follows = () => import(/* webpackChunkName: "group-private" */ '../Follows.vue')
const ProfileSettingsLayout = () => import(/* webpackChunkName: "group-private" */ '../ProfileSettingsLayout.vue')
const ProfileSettings = () => import(/* webpackChunkName: "group-private" */ '../Profilesettings--profile.vue')
const FrontpageSettings = () => import(/* webpackChunkName: "group-private" */ '../Profilesettings--frontpage-settings.vue')
const ArticlesLayout = () => import(/* webpackChunkName: "group-private" */ '../ArticlesLayout.vue')
const ArticlesList = () => import(/* webpackChunkName: "group-private" */ '../ArticlesLayout--list.vue')
const ArticlesEditor = () => import(/* webpackChunkName: "group-private" */ '../ArticlesLayout--editor.vue')



export default [
  {
    path: "/private",
    name: "private",
    component: Layout,
    title: "private",
    redirect: { name: "editprofile" },
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardLayout,
        redirect: { name: "editprofile" }
      },
      { path: "managefeeds", name: "managefeeds", component: ManageFeeds },
      { path: "inbox", name: "inbox", component: Inbox },
      { path: "follows", name: "follows", component: Follows },
      {
        path: "profilesettings",
        name: "profilesettings",
        component: ProfileSettingsLayout,
        redirect: { name: "editprofile" },
        children: [
          { path: "profile", name: "editprofile", component: ProfileSettings },
          {
            path: "frontpage",
            name: "editfrontpagesettings",
            component: FrontpageSettings
          }
        ]
      },
      {
        path: "articles",
        name: "articles",
        component: ArticlesLayout,
        redirect: { name: "listarticles" },
        children: [
          { path: "list", name: "listarticles", component: ArticlesList },
          { path: "create ", name: "createarticle", component: ArticlesEditor },
          {
            path: "edit/:articleid",
            name: "editarticle",
            component: ArticlesEditor
          }
        ]
      },
      {
        path: "createArticle",
        name: "create article",
        component: ArticlesEditor,
        redirect: { name: "createarticle" }
      },
      { path: "*", redirect: "createArticle" }
    ]
  }
];
